import { memo } from 'react';

interface BalloonTooltipProps {
  variant: 'idle' | 'preheating' | 'paused';
  headline: string;
  sub?: string | null;
  icon: string;
  bounce?: boolean;
  progressPct?: number;
  showProgress?: boolean;
}

export const BalloonTooltip = memo(
  ({ variant, headline, sub, icon, bounce, progressPct = 0, showProgress }: BalloonTooltipProps) => (
    <div
      className={[
        'balloon-tooltip',
        `balloon-tooltip--${variant}`,
        bounce && 'balloon-tooltip--bounce',
      ]
        .filter(Boolean)
        .join(' ')}>
      <div className="balloon-tooltip__inner">
        <img className="balloon-tooltip__icon" src={icon} alt="" />
        <div className="balloon-tooltip__text">
          <span className="balloon-tooltip__headline">{headline}</span>
          {sub && <span className="balloon-tooltip__sub">{sub}</span>}
        </div>
      </div>
      {showProgress && (
        <div className="balloon-tooltip__bar">
          <div className="balloon-tooltip__fill" style={{ width: `${progressPct}%` }} />
        </div>
      )}
    </div>
  ),
);
